import { render, staticRenderFns } from "./ContractsChurnTotalizer.vue?vue&type=template&id=444ed768"
import script from "./ContractsChurnTotalizer.vue?vue&type=script&lang=js"
export * from "./ContractsChurnTotalizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports